// @flow

const getConfiguration = (props: any): any => {
    return {
        enableToolbar: false,
        enableHeader: false,
    }
}
export default getConfiguration;